<div class="container-fluid">
  <embed
    class="w-100"
    style="text-align: center"
    type="text/html"
    [src]="this.embedUrl | safeUrl"
  />
</div>
